// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getOnePageCheckoutProductListOverlay = (state: ApplicationState) => {
    return state.starter.components.onePageCheckoutProductListOverlay;
};
